import { LoadingStateTypes } from '@beeline/design-system-react/types/components/Button/ProgressButton/ProgressButton.types';

import { EmployeeShortInfo } from './api/types';

export enum BookingState {
  Accepted = 'accepted',
  BookingInProgress = 'bookingInProgress',
  UnbookingInProgress = 'unbookingInProgress',
}

export interface BookingData {
  bookingId: string;
  bookedFrom: string;
  bookedTo: string;
  responsibleEmployeeNumber: string | null;
  authorEmployeeNumber: string | null;
  state: BookingState;
}

export interface FreePeriod {
  from: string;
  to: string;
}

export interface BookingInProgressData {
  bookedFrom: string;
  bookedTo: string;
  responsibleEmployeeNumber: string | null;
  authorEmployeeNumber: string | null;
}

export interface ParkingBookingData {
  bookingId: string;
  bookedFrom: string;
  bookedTo: string;
  responsibleEmployeeNumber: string | null;
  authorEmployeeNumber: string | null;
  guestName: string | null;
  carModel: string | null;
  carNumber: string | null;
  needPass: boolean;
  state: BookingState;
}

export enum PlaceType {
  Desk = 1,
  Room = 2,
  Parking = 3,
}

export enum RoomType {
  Focus = 1,
  Meeting = 2,
  Phone = 3,
}

export type Interval = ReturnType<typeof setInterval>;

export type Timeout = ReturnType<typeof setTimeout>;

export interface Rect {
  type: 'rect';
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export interface Circle {
  type: 'circle';
  x: number;
  y: number;
  radius: number;
}

export type GeometryForm = Rect | Circle;

export interface TimePeriod {
  from: string | undefined;
  to: string | undefined;
}

export interface TimeBounds {
  min: string | undefined;
  max: string | undefined;
  error: string | undefined;
}

export interface BaseBookingObject {
  id: number | undefined;
  mapPlaceId: string;
  title: string | undefined;
  x: number;
  y: number;
  width: number;
  height: number;
  fontSize: number;
  status?: BookingData | null;
  spaceId?: number | null;
}

export interface Desk extends BaseBookingObject {
  type: PlaceType.Desk;
  rotation: number;
  responsible: EmployeeShortInfo | null;
  responsibleEmployeeNumber: string | null;
  byWindow?: boolean;
  withMonitor?: boolean;
  withCharger?: boolean;
  withDivider?: boolean;
}

export interface Room extends BaseBookingObject {
  type: PlaceType.Room;
  roomType?: RoomType;
  square?: number;
  seatCount?: number;
  withTv?: boolean;
  withVideoCalls?: boolean;
  withFlipChart?: boolean;
  withWater?: boolean;
  adEmail?: string;
}

export interface Parking extends BaseBookingObject {
  type: PlaceType.Parking;
  responsible: EmployeeShortInfo | null;
  responsibleEmployeeNumber: string | null;
  guest: boolean;
  shared: boolean;
  status?: ParkingBookingData;
  rotation: number;
  spaceAdministrator?: string;
}

export type BookingObject = Desk | Room | Parking;

export interface ProgressState {
  key?: string;
  state?: LoadingStateTypes;
}

export enum DeviceSize {
  XXS = 'XXS',
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
}

export interface CarInfo {
  model: string | null;
  number: string | null;
}
